export function QuoteCard() {
  return (
    <div className="bento-no-min row-span-3 flex flex-col h-full">
      <h3 className="font-heading text-md [@media(min-width:414px)]:text-lg text-foreground mb-4">
        Builder With a Business Mindset
      </h3>
      <p className="font-body text-sm text-muted-foreground font-light leading-relaxed">
        "Whether it’s a MERN app, an AI-powered workflow, or a smooth GSAP animation, my focus stays the same — build things that are useful, reliable, and genuinely move the project forward. Good tech should make life easier, not complicated."
      </p>
    </div>
  );
}
